import { useSyncExternalStore } from 'react';

interface Toast { id: number; text: string; tone: 'ok' | 'bad' | 'info'; action?: { label: string; run: () => void } }
let list: Toast[] = [];
const subs = new Set<() => void>();
const emit = () => subs.forEach((s) => s());
let n = 0;
const timers = new Map<number, ReturnType<typeof setTimeout>>();
const later = (id: number, ms: number) => { clearTimeout(timers.get(id)); timers.set(id, setTimeout(() => dismiss(id), ms)); };
/** The pointer or the keyboard is on a toast: it waits (an Undo can be reached), and goes 4 s after they leave. */
const hold = (id: number) => { clearTimeout(timers.get(id)); timers.delete(id); };
const release = (id: number) => { if (list.some((t) => t.id === id)) later(id, 4000); };

export function toast(text: string, tone: Toast['tone'] = 'info', action?: Toast['action']) {
  const t = { id: ++n, text, tone, action };
  list = [...list.slice(-2), t];
  emit();
  later(t.id, action ? 7000 : tone === 'bad' ? 6000 : 3500);
}
export const toastOk = (t: string, action?: Toast['action']) => toast(t, 'ok', action);
export const toastBad = (t: string) => toast(t, 'bad');
function dismiss(id: number) {
  hold(id);
  list = list.filter((t) => t.id !== id);
  emit();
}

export function Toasts() {
  const items = useSyncExternalStore((s) => (subs.add(s), () => subs.delete(s)), () => list);
  return (
    // One live region, on the page before any toast, so each new one is read out.
    <div role="status" aria-live="polite" className="pointer-events-none fixed inset-x-0 bottom-[84px] z-[60] flex flex-col items-center gap-2 px-4 lg:bottom-6">
      {items.map((t) => (
        <div key={t.id} onMouseEnter={() => hold(t.id)} onMouseLeave={() => release(t.id)} onFocus={() => hold(t.id)} onBlur={() => release(t.id)} className="animate-rise pointer-events-auto flex min-h-12 w-full max-w-[440px] items-center gap-3 rounded-2xl bg-[#17191f] px-4 py-2.5 text-[14px] text-white shadow-2 ring-1 ring-white/10">
          <span aria-hidden="true" className={`h-2 w-2 shrink-0 rounded-full ${t.tone === 'bad' ? 'bg-[#ff8a80]' : t.tone === 'ok' ? 'bg-[#6ee7a8]' : 'bg-[#a3aeff]'}`} />
          <span className="flex-1">{t.text}</span>
          {t.action ? <button type="button" className="rounded-lg px-2 py-1 font-semibold text-[#a9b3ff] hover:bg-white/10" onClick={() => { t.action!.run(); dismiss(t.id); }}>{t.action.label}</button> : null}
        </div>
      ))}
    </div>
  );
}
